import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Nav from "@/components/Nav";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Nav />
      <div className="mx-auto max-w-2xl px-6 py-32 text-center">
        <p className="text-xs font-medium uppercase tracking-[0.32em] text-stone-500">Paiement</p>
        <h1 className="font-display mt-4 text-5xl font-light text-stone-900">Paiement annulé.</h1>
        <p className="mt-6 text-base font-light text-stone-500">Aucun montant n'a été prélevé. Vous pouvez retenter à tout moment.</p>
        <Button data-testid="cancel-back-home" onClick={() => nav("/")} className="mt-10 rounded-full bg-stone-900 px-8 py-6 hover:bg-stone-800">Retour aux forfaits</Button>
      </div>
    </div>
  );
}
